import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase/config';
import DashboardNav from './DashboardNav';
import './Dashboard.css';

const Dashboard = () => {
  const { currentUser } = useAuth();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (!currentUser) return;

    const userRef = ref(database, `utilisateurs/${currentUser.uid}`);
    const unsubscribe = onValue(userRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setUserInfo(data);
      }
    });

    return () => unsubscribe();
  }, [currentUser]);

  // Obtenir le nom complet
  const getFullName = () => {
    if (userInfo?.prenom && userInfo?.nom) {
      return `${userInfo.prenom} ${userInfo.nom}`;
    }
    if (userInfo?.prenom) {
      return userInfo.prenom;
    }
    return currentUser?.email?.split('@')[0] || 'Client';
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Bonjour, {getFullName()} !</h1>
          <p>Gérez vos déménagements et suivez vos activités</p>
        </div>
      </div>
      
      <div className="dashboard-layout">
        <DashboardNav />
        <div className="dashboard-content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;